import type { MentorMe } from './types';

export type ProfileCtaState = 'empty' | 'partial' | 'complete';

export type ProfileProgress = {
  percent: number;
  state: ProfileCtaState;
};

const MENTOR_FIELD_COUNT = 9;

function filled(value: string | null | undefined): boolean {
  return Boolean(value?.trim());
}

/**
 * Marketplace-oriented completeness for the mentor dashboard card.
 * Counts fields students need to discover a mentor (current API surface).
 */
export function computeMentorProfileProgress(
  mentor: MentorMe | null | undefined,
): ProfileProgress {
  if (!mentor) {
    return { percent: 0, state: 'empty' };
  }

  const profile = mentor.profile;
  const checks = [
    filled(profile?.displayName),
    filled(profile?.headline),
    filled(profile?.description),
    filled(profile?.goals),
    filled(profile?.avatarUrl),
    filled(profile?.timezone),
    (profile?.nativeLanguages?.length ?? 0) > 0,
    profile?.experienceYears != null && profile.experienceYears >= 0,
    (mentor.categoryIds?.length ?? 0) > 0,
  ];

  const done = checks.filter(Boolean).length;
  const percent = Math.round((done / MENTOR_FIELD_COUNT) * 100);

  if (percent >= 100) return { percent: 100, state: 'complete' };
  if (percent === 0) return { percent: 0, state: 'empty' };
  return { percent, state: 'partial' };
}
